import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../../models'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    render: store.actions.request({
      input: store.actions.Data.asIs<models.widget.Request>(),
      output: store.actions.Data.asIs<{
        rendering: ents.core.mosaic.Widget.Rendering
      }>(),
      reducers: {
        request: ({ data: { ref }, state }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [ref.id]: {
              isLoading: true,
              // We leave the old rendering on request, while we wait for the
              // new rendering to take its place
              rendering: state.lookup[ref.id]?.rendering,
            },
          },
        }),
        success: ({
          data: {
            request: { ref },
            response: { rendering },
          },
          state,
        }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [ref.id]: {
              isLoading: false,
              rendering,
            },
          },
        }),
        error: ({
          data: {
            request: { ref },
            error,
          },
          state,
        }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [ref.id]: { isLoading: false, error },
          },
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
